import axios from 'axios'
import router from "../router";

const request = axios.create({
    baseURL: '/api',
    timeout: 5000
})

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
    // 只有当Content-Type未设置时，才设置为application/json;charset=utf-8
    if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
    }
    
    // config.headers['token'] = user.token;  // 设置请求头
    //取出sessionStorage里面缓存的用户信息
// 取出sessionStorage里面缓存的用户信息
let userJson = sessionStorage.getItem("user")
// 如果有用户信息，设置token
if (userJson) {
    let user = JSON.parse(userJson)
    console.log(config)
    if (user.token) {
        config.headers['token'] = user.token
    }
}
// 注册和登录请求不需要检查用户信息
if (!userJson && !config.url.includes('register') && !config.url.includes('login')) {
    router.push("/login")
}
    return config
}, error => {
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        let res = response.data;
        // 如果是返回的文件
        if (response.config.responseType === 'blob') {
            return res
        }
        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        return res;
    },
    error => {
        console.log('err' + error) // for debug
        return Promise.reject(error)
    }
)


export default request

